// @flow
import { handleActions } from 'redux-actions';
import { SWITCH_COORDINATE_SYSTEM } from 'esm-web-pro/redux/networks/constants';

const DEFAULT_COORDINATE_SYSTEM = 'EPSG:4326';

export type State = { coordinateSystem?: string };

const initialState: State = {
    coordinateSystem: DEFAULT_COORDINATE_SYSTEM,
};

const reducer = handleActions({
    [SWITCH_COORDINATE_SYSTEM]: (state: State, { payload }: {
        payload: {}
    }) => {
        if (state.coordinateSystem === DEFAULT_COORDINATE_SYSTEM) {
            return { ...state, coordinateSystem: process.env.REACT_APP_GIS_TRANSFORM_COORDINATE_SYSTEM };
        }
        return initialState;
    },
}, initialState);

export default reducer;
